import { styled } from '$utils/theme'
import { Icon } from '$views/components/Icon'

export const WrapperCaretakerCard = styled.div`
  display: grid;
  grid-template-columns: min-content auto;
`
export const PointerHoverBlock = styled.div`
  &:hover {
    cursor: pointer;
  }
  display: flex;
  align-items: center;
`

export const ProIcon = styled(Icon)`
  position: absolute;
  bottom: 0;
  left: 2rem;
`



// WEBPACK FOOTER //
// ./src/views/CaretakerRecommendation/Components/RecommendationCaretakerCard/RecommendationCaretakerCard.style.ts